import { Component, ViewChild, TemplateRef, OnChanges, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { BsDatepickerConfig, DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { TaskActionsHistoryComponent } from '../task-actions-history/task-actions-history.component';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
import { MatTabGroup } from '@angular/material/tabs';
import moment from 'moment-timezone';
import { forkJoin, switchMap } from 'rxjs';
import { AddMapCapaComponent } from '../add-map-capa/add-map-capa.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';
import { QualityDependentsComponent } from '../quality-dependents/quality-dependents.component';

@Component({
  selector: 'app-oos',
  templateUrl: './oos.component.html',
  styleUrls: ['./oos.component.scss']
})
export class OosComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

  isProcessing = true;
  oos: any = {};

  departmentList: any = [];
  designationList: any = [];
  ownerList: any = [];
  qaList: any = [];
  analyserList: any = [];
  departmentHeadList: any = [];
  typeList: any = [];
  locationList: any = [];
  productList: any = [];
  reportTemplateList: any = [];
  reportImageList: any = [];
  reportLogoList: any = {};
  batchDispositionList: any = [];
  instrumentIdList: any = [];
  attachAllDocuments: boolean = false;
  departmentDropDown: any = [];
  designationDropDown: any = [];
  ownerDropDown: any = [];
  qaDropDown: any = [];
  analyserDropDown: any = [];
  departmentHeadDropDown: any = [];
  oosTypeDropDown: any = [];
  locationDropDown: any = [];
  productDropDown: any = [];
  reportTemplateDropDown: any = [];
  reportLogoDropDown: any = [];
  batchDispositionDropdown: any = [];
  instrumentIdDropdown: any = [];

  InitiatingDepartmentSearchText: string = '';
  departmentSearchText: string = '';
  ownerSearchTxt: string = '';
  analyzedBySearchText: string = '';
  departmentHeadSearchText: string = '';
  qaSearchText: string = '';
  typeSearchText: string = '';
  locationSearchText: string = '';
  analyserSearchText: string = '';
  designationSearchText: string = '';
  productSearchText: string = '';
  reportTemplateSearchText: string = '';
  reportLogoSearchText: string = '';
  batchDispositionSearchText: string = '';
  instrumentSearchText: string = '';

  selectedReportTemplate: any = null;
  isAnalyzedByOdd: any = null;
  isDhOdd: any = null;
  isQaApproveOdd: any = null;
  isQaAcceptanceOdd: any = null;
  oddLocation: any = null;
  isBatchDispositionOdd: any = null;
  isInstrumentMasterOdd: any = null;

  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  isStageUsersSkipped: boolean = false;
  addWorkflow: boolean = false;
  activityData: boolean = false;
  parallelWorkflowList: any = [];
  stageName: any;
  actionStatusOptions: any;
  instructions: any = [];
  snackbarRef: any;
  reportName: string = '';
  docObj: any;
  markDelayLoggingAsMandatory: boolean = false;
  isLocationIfOthers: boolean = false;
  isProductIfOthers: boolean = false;
  isBatchRejectReason: boolean = false;
  buttonLabels: any;
  isPhaseII: boolean = false;
  isPhaseIII: boolean = false;
  isAnalytical: boolean = false;
  isMicrobiology: boolean = false;
  isAdditionalTabUser: boolean = false;

  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(
    readonly router: Router,
    readonly dialog: MatDialog,
    readonly message: messageService,
    readonly qualityService: qmsService,
    readonly taskActionsHistoryComponent: TaskActionsHistoryComponent,
    public dependencyNavigationService: DependencyNavigationService,

    private readonly snackBar: MatSnackBar,
    private readonly appService: AppService,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.selectedTabIndex = 0;
    this.isAdditionalTabUser = this.qualityService?.userRole[0]?.qmsRoles?.includes("Additional Tab User");
    this.getTaskStages();
  }

  ngOnChanges(): void {
    this.qualityService.refereshBreadCrumb = true;
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit(): void {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.main();

    this.dependencyNavigationService.refresh.subscribe(() => {
      if (this.qualityService.moduleName == 'OOS') {
        this.main();
      }
    });

  }

  ngAfterViewInit() {
    this.lastSelectedTabIndex = this.selectedTabIndex;
    const tab = this.tabsGroup?._tabs.get(this.selectedTabIndex);
    this.selectedTab = this.qualityService.selectedTabName = tab?.textLabel;
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  private getTaskStages(): void {
    this.appService.getTaskStages(this.qualityService.activityId, 0).subscribe((stage: any) => {
      this.isStageUsersSkipped = !stage?.length;
    })
  }

  private main(): void {
    this.isProcessing = true;
    this.buttonLabels = [];

    this.typeList = JSON.parse(sessionStorage.getItem('dropDownForOosType') ?? '{}');
    this.departmentList = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.designationList = JSON.parse(sessionStorage.getItem('designationListCode') ?? '[]');

    const userObj = { status: 'Active' };
    const groupId = this.qualityService.selectedGroup;
    const activityId = this.message.activityId;
    const moduleName = this.qualityService.moduleName;
    const getOwner$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, 'Owner');
    const getQA$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, 'QA');
    const getAnalyser$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, 'Analyser');
    const getDepartmentHead$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, 'Department Head');
    const getParallelWorkflowList$ = this.appService.getWorkflowByRefNo(activityId);
    const getAllLocationsByLocationMaster$ = this.appService.getAllLocations();
    const getQualityUserList$ = this.appService.getOneQmsUsersVwDetails(userObj);
    const getreportTemplateList$ = this.appService.getQmsReportTemplateDetailsByModuleAndGroupId(moduleName, groupId);
    const getProducts$ = this.appService.getQmsProductMasterVwDetails();
    const getReportImage$ = this.appService.getOneQmsOrganizationReportImage();
    const getReportLogo$ = this.appService.getQmsReportLogoByModuleAndGroupId("QMS", groupId);
    const getCodeListsByBatchDisposition$ = this.appService.getCodeListsByGroup("BATCH_DISPOSITION_DECISION");
    const getInstruments$ = this.appService.getAllInstruments();

    this.docObj = { id: activityId, pagename: "Activity" };
    this.ngOnChangesReportFooter();
    forkJoin([
      getOwner$,
      getQA$,
      getAnalyser$,
      getDepartmentHead$,
      getParallelWorkflowList$,
      getAllLocationsByLocationMaster$,
      getQualityUserList$,
      getreportTemplateList$,
      getProducts$,
      getReportImage$,
      getReportLogo$,
      getCodeListsByBatchDisposition$,
      getInstruments$
    ]).pipe(
      switchMap((
        [owner, qa, analyser, departmentHead, parallelWorkflow, location, qualityUsers, reportTemplate, products, reportImage, reportLogo, batchDisposition, instrument]
      ) => {
        this.selectBoxForDepartment();
        this.selectBoxForDesignation();
        this.selectBoxForType();

        this.ownerList = owner;
        this.selectBoxForOwner();

        this.qaList = qa;
        this.selectBoxQA();

        this.analyserList = analyser;
        this.selectBoxForAnalyser();

        this.departmentHeadList = departmentHead;
        this.selectBoxForDepartmentHead();

        this.locationList = location;
        this.selectBoxForLocations();

        this.productList = products;
        this.selectBoxForProduct();

        this.reportTemplateList = reportTemplate;
        if (this.reportTemplateList.length) this.selectBoxForReportTemplate();

        this.organizationReportImageDetails = reportImage;
        this.dropDownDataForReportLogo = reportLogo;
        this.selectBoxForReportLogo();

        this.batchDispositionList = batchDisposition;
        if (this.batchDispositionList.length) this.selectBoxForBatchDisposition();

        this.instrumentIdList = instrument;
        this.instrumentIdList.length && this.instrumentIdList.sort((m: { instrumentId: string }, n: { instrumentId: string }) => m?.instrumentId?.localeCompare(n?.instrumentId));

        this.parallelWorkflowList = parallelWorkflow;
        this.reportImageList = reportImage;
        this.qualityUserList = qualityUsers;

        return this.appService.getOosByOosNo(activityId);
      })).subscribe((oos: any) => {

        this.oos = oos[0];

        this.isAnalytical = this.oos.isAnalyticalLabInvestigationReqd = this.oos.isAnalyticalLabInvestigationReqd == "Y";
        this.isMicrobiology = this.oos.isMicrobiologyLabInvestigationReqd = this.oos.isMicrobiologyLabInvestigationReqd == "Y";
        this.isPhaseII = this.oos.phaseIIInvestigationReqd = this.oos.phaseIIInvestigationReqd == "Y";
        this.isPhaseIII = this.oos.phaseIIIInvestigationReqd = this.oos.phaseIIIInvestigationReqd == "Y";
        this.oos.isClientIntimationReqd = this.oos.isClientIntimationReqd == "Y";
        this.oos.phaseIIRetestingReqd = this.oos.phaseIIRetestingReqd == "Y";
        this.oos.phaseIIIsRootCauseIdentifiedAtRetesting = this.oos.phaseIIIsRootCauseIdentifiedAtRetesting == "Y";
        this.oos.phaseIIIRetestingReqd = this.oos.phaseIIIRetestingReqd == "Y";
        this.oos.phaseIIIIsRootCauseIdentifiedAtRetesting = this.oos.phaseIIIIsRootCauseIdentifiedAtRetesting == "Y";
        this.oos.isCapaReqd = this.oos.isCapaReqd == "Y";
        this.oos.isRecurring = this.oos.isRecurring == "Y";

        this.oos.initiatedOn = this.oos.initiatedOn ? new Date(this.oos.initiatedOn) : null;
        this.oos.dateOfOccurrence = this.oos.dateOfOccurrence ? new Date(this.oos.dateOfOccurrence) : null;
        this.oos.identifiedOn = this.oos.identifiedOn ? new Date(this.oos.identifiedOn) : null;
        this.oos.expcetedClosureOn = this.oos.expcetedClosureOn ? new Date(this.oos.expcetedClosureOn) : null;
        this.oos.expectedToBeStartedOn = this.oos.expectedToBeStartedOn ? new Date(this.oos.expectedToBeStartedOn) : null;
        this.oos.startedOn = this.oos.startedOn ? new Date(this.oos.startedOn) : null;
        this.oos.completedOn = this.oos.completedOn ? new Date(this.oos.completedOn) : null;
        this.oos.lastActionOn = this.oos.lastActionOn ? new Date(this.oos.lastActionOn) : null;

        this.qualityService.activity = this.oos;

        this.getDynamicButtons();
        this.getDynamicLabel();
        this.getDelayLoggingMandatory();
        this.setDropDowns();
        this.setStatusDependentAesthetic();
        this.getStageUsers();
      })
  }

  private setDropDowns() {
    if (this.oos.locationId) {
      const matchingLocation = this.locationList?.find((location: any) => location.locationId == this.oos.locationId)
      this.isLocationIfOthers = matchingLocation.locationName?.trim()?.toLowerCase() == 'others';
    }

    if (this.oos.productOrMaterialName) {
      this.isProductIfOthers = this.oos.productOrMaterialName?.trim()?.toLowerCase() == 'others';
    }

    if (this.oos.batchDisposition) {
      this.isBatchRejectReason = this.oos.batchDisposition?.trim()?.toLowerCase() == 'reject';
    }

    if (this.oos.notifyTo) {
      const matchingNotifyUsers: [] = this.oos.notifyTo?.split(',')?.map((splittedUserId: any) => this.qualityUserList?.find((user: any) => user.userId == splittedUserId))
      if (matchingNotifyUsers.length) {
        this.selectedNotifyUsers = matchingNotifyUsers?.map((user: any) => ({
          userId: user.userId,
          userName: user.userName
        }))
      } else {
        this.selectedNotifyUsers = [];
      }
    } else {
      this.selectedNotifyUsers = [];
    }

    if (this.oos.investigationTeam) {
      const matchingInvestigationUsers: [] = this.oos.investigationTeam?.split(',')?.map((splittedUserId: any) => this.qualityUserList?.find((user: any) => user.userId == splittedUserId))
      if (matchingInvestigationUsers.length) {
        this.selectedInvestigationUsers = matchingInvestigationUsers?.map((user: any) => ({
          userId: user.userId,
          userName: user.userName
        }))
      } else {
        this.selectedInvestigationUsers = [];
      }
    } else {
      this.selectedInvestigationUsers = [];
    }
  }

  public getDelayLoggingMandatory(): boolean {
    const initiated = new Date(this.qualityService.activity.initiatedOn);
    const identified = new Date(this.qualityService.activity.identifiedOn);

    initiated.setHours(0, 0, 0, 0); /* Strip time part */
    identified.setHours(0, 0, 0, 0);

    const oneDayMs = 24 * 60 * 60 * 1000;

    this.markDelayLoggingAsMandatory = (initiated.getTime() - identified.getTime()) >= oneDayMs;

    return this.markDelayLoggingAsMandatory;
  }

  private processButtonLabels(buttonLabels: string[] | null): string[] {
    const labels = buttonLabels ? [...buttonLabels] : [];
    labels.unshift("Cancel");  // Always add Cancel
    this.qualityService.activityDynamicButtonList = labels;

    // Reset flags
    this.qualityService.showflexifieldshow = false;
    this.qualityService.activitySaveButton = false;

    for (const element of labels) {
      if (/Submit|Review|Approve|Accept/.test(element)) {
        this.qualityService.showflexifieldshow = true;
      }
      if (element === "Save") {
        this.qualityService.activitySaveButton = true;
      }
    }

    return labels;
  }

  private getDynamicButtons(): void {
    const obj = {
      activityId: this.message.activityId,
      moduleName: this.qualityService.moduleName,
      status: this.oos.status
    }

    this.appService.getQmsButtons(obj).subscribe((data: any) => {
      this.qualityService.activityDynamicButtonList = [];
      this.buttonLabels = [];
      this.qualityService.activitySaveButton = false;

      if (data.resultType === "S") {
        this.qualityService.showflexifieldshow = false;
        this.stageName = data.stageName;
        this.actionStatusOptions = data.actionStatusOptions;
        this.instructions = data.instructions;
        this.qualityService.activityButtonLabels = data;
        this.buttonLabels = this.processButtonLabels(data.buttonLabels?.split(",") || null);

      } else {
        this.buttonLabels = this.processButtonLabels(null);
        this.showSnackBar(data.result, data.resultType);
      }
    });
  }

  private selectBoxForDepartment(): void {
    this.departmentDropDown = this.departmentList?.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  public onInitiatingDepartmentSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('initiating-department', item);
    }
  }

  public onDepartmentSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('department', item);
    }
  }

  private selectBoxForDesignation(): void {
    this.designationDropDown = this.designationList?.map((designation: any) => ({
      valueExp: designation.codelistCode,
      displayExp: designation.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  private selectBoxForType(): void {
    this.oosTypeDropDown = this.typeList.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  private selectBoxForOwner(): void {
    this.ownerDropDown = this.ownerList?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  public onOwnerSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('owner', item);
    }
  }

  public selectBoxQA(): void {
    this.qaDropDown = [];
    this.qaDropDown = this.qaList?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  public onQaApproveSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('qa', item);
    }
  }

  public onQaAcceptanceSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('qa-acceptance', item);
    }
  }

  private selectBoxForAnalyser(): void {
    this.analyserDropDown = [];
    this.analyserDropDown = this.analyserList?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  public onAnalyserSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('analyser', item);
    }
  }

  private selectBoxForDepartmentHead(): void {
    this.departmentHeadDropDown = [];
    this.departmentHeadDropDown = this.departmentHeadList?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  public onDepartmentHeadSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('department-head', item);
    }
  }

  public onOosDepartmentHeadSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('oos-department-head', item);
    }
  }

  private selectBoxForLocations(): void {
    this.locationDropDown = [];
    this.locationDropDown = this.locationList?.map((item: any) => ({
      valueExp: item.locationId,
      displayExp: item.locationName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  public onLocationSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('location', item);
      if (item) this.isLocationIfOthers = item.displayExp?.trim()?.toLowerCase() == 'others';
      else this.isLocationIfOthers = false;
      this.qualityService.activity.locationIfOthers = null;
    }
  }

  private selectBoxForProduct(): void {
    this.productDropDown = [];
    this.productDropDown = this.productList.map((item: { productId: any; productName: any; }) => ({
      valueExp: item.productName,
      displayExp: item.productName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onProductSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('product-or-material-name', item);
      if (item)
        this.isProductIfOthers = item?.displayExp?.trim()?.toLowerCase() == 'others';
      else
        this.isProductIfOthers = false;
    }
  }

  private selectBoxForBatchDisposition(): void {
    this.batchDispositionDropdown = this.batchDispositionList.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onBatchDispositionSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('batch-disposition', item);
      if (item)
        this.isBatchRejectReason = item?.displayExp?.trim()?.toLowerCase() == 'reject';
      else
        this.isBatchRejectReason = false;
    }
  }

  public onInstrumentsSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('instrument-master', item);

      const currentVal = this.qualityService.activity.instrumentOrEquipmentName || '';
      const detail = `Instrument ID: ${item.instrumentId}, Instrument Name: ${item.instrumentName}`;
      const entries = currentVal ? currentVal.split('\n') : [];

      if (event.source.selected) {
        if (!entries.includes(detail)) {
          entries.push(detail);
        }
      } else {
        // Remove if deselected
        const index = entries.indexOf(detail);
        if (index !== -1) {
          entries.splice(index, 1);
        }
      }

      this.qualityService.activity.instrumentOrEquipmentName = entries.join('\n');
    }
  }

  @ViewChild('instrument') instrument: MatSelect;
  @ViewChild(QualityDependentsComponent) dependentsComp!: QualityDependentsComponent;
  public openDependentsPopup(): void {
    this.dependentsComp.openPopup();
  }
  instrumentSelection = false;

  public toggleAllSelection(value: any): void {
    if (value === 'instrument') {
      if (this.instrumentSelection) {
        this.instrument.options.forEach((item: MatOption) => item.select());

        // Add all instrument details
        this.qualityService.activity.instrumentOrEquipmentName = this.instrumentIdDropdown.map((item: any) =>
          `Instrument ID: ${item.instrumentId}, Instrument Name: ${item.instrumentName}`
        );
      } else {
        this.instrument.options.forEach((item: MatOption) => item.deselect());
        this.qualityService.oosDropdowns.selectedInstrumentId = [];
        this.qualityService.activity.instrumentOrEquipmentName = [];
      }

      setTimeout(() => {
        this.handleDropDownValidation('instrument', this.qualityService.oosDropdowns.selectedInstrumentId);
      });
    }
  }

  visibleAlertPopup!: MatDialogRef<TemplateRef<any>>;
  @ViewChild('alertPopup', { static: true }) alertPopup!: TemplateRef<any>;

  alertPopupConfig = {
    width: '450px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: false,
    position: { top: '10px' }
  };

  selectedTabIndex = 0;
  private lastSelectedTabIndex = 0;
  selectedTab: any;
  skipValidationsWhileSwitchingUser: boolean = false;
  private suppressTabChange = false;
  pendingTabIndex: number | null = null;

  public onTabChanged(event: any): void {
    if (this.suppressTabChange) {
      this.suppressTabChange = false;
      return;
    }

    const newTabIndex = event.index;
    const newTabLabel = event.tab.textLabel;

    const tabs = this.tabsGroup._tabs.toArray();
    const currentTabLabel = tabs[this.lastSelectedTabIndex]?.textLabel;

    const isLeavingSensitiveTab =
      (currentTabLabel === 'Analytical' || currentTabLabel === 'Microbiology' || currentTabLabel === 'Data Evaluation') && this.qualityService.isChangeDetectedInOos;

    if (isLeavingSensitiveTab) {
      this.pendingTabIndex = newTabIndex;  /* Save the new tab index for later use */
      this.visibleAlertPopup = this.dialog.open(this.alertPopup, this.alertPopupConfig);
    } else {
      this.switchTab(newTabIndex, newTabLabel);
    }
  }

  public closeAlertPopup(confirmed: boolean = false): void {
    this.visibleAlertPopup?.close();

    if (confirmed && this.pendingTabIndex !== null) {
      const tab = this.tabsGroup._tabs.get(this.pendingTabIndex);
      this.switchTab(this.pendingTabIndex, tab?.textLabel);
    } else {
      // Cancel tab change and reset the selection
      this.suppressTabChange = true;
      setTimeout(() => {
        this.selectedTabIndex = this.lastSelectedTabIndex;
      });
    }

    this.pendingTabIndex = null;
  }

  private switchTab(index: number, label: any): void {
    this.lastSelectedTabIndex = index;
    this.selectedTabIndex = index;
    this.selectedTab = this.qualityService.selectedTabName = label;
  }

  @ViewChild('tabsGroup', { static: false }) tabsGroup!: MatTabGroup;
  set tabGroup(tabGroup: MatTabGroup) {
    if (tabGroup)
      setTimeout(() => { this.selectedTabIndex = tabGroup._tabs["_results"].find((t: any) => t.textLabel == this.selectedTabIndex).position; }, 0);
  }

  public goToTabByLabel(label: string): void {
    if (this.tabsGroup) {
      const tabs = (this.tabsGroup?._tabs as any)._results,
        match = tabs?.find((x: any) => x.textLabel?.toUpperCase() === label.toUpperCase());

      if (match) {
        this.tabsGroup.selectedIndex = match.position;
      }
    }
  }

  public onExpectedToBeStartedOnChange(): void {
    if (this.oos.expcetedClosureOn && (this.oos.expcetedClosureOn < this.oos.expectedToBeStartedOn)) this.oos.expcetedClosureOn = null;
  }

  public readonly commonDateConfig: Readonly<Partial<BsDatepickerConfig>> = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  public readonly dateTimeConfig: Readonly<Partial<BsDatepickerConfig>> = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }

  public getExpectedClosureDateConfig(): Partial<BsDatepickerConfig> {
    return {
      ...this.commonDateConfig,
      ...(this.qualityService.moduleName == 'OOS') && { minDate: this.oos.expectedToBeStartedOn ? new Date(this.oos.expectedToBeStartedOn) : new Date() },
    }
  }

  public readonly expectedToBeStartedOnConfig: Readonly<Partial<BsDatepickerConfig>> = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  public readonly $present_future_config: Readonly<Partial<BsDatepickerConfig>> = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  public readonly $past_present_config: Readonly<Partial<BsDatepickerConfig>> = {
    ...this.commonDateConfig,
    maxDate: new Date()
  }

  public $identified_on_dynamic_config(): Partial<BsDatepickerConfig> {
    return {
      ...this.commonDateConfig,
      minDate: this.oos.dateOfOccurrence ? new Date(this.oos.dateOfOccurrence) : new Date(),
      maxDate: new Date(this.oos.initiatedOn)
    }
  }

  public onOosOccurrenceChange(): void {
    if (this.qualityService.activity.identifiedOn && (this.qualityService.activity.dateOfOccurrence < this.qualityService.activity.identifiedOn)) this.qualityService.activity.identifiedOn = null;
  }

  userTimeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  public calcTimeZone(items: any): void {
    const localDate = moment.tz(items, this.userTimeZone).format();
    console.log('Selected Date in User Time Zone:', localDate);

    // Convert to UTC or any other time zone if needed
    const utcDate = moment(items).utc().format();
    console.log('Selected Date in UTC:', utcDate);
  }

  public limitCharacters(event: Event, field: any): void {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      4000: ['SHORT_DESCRIPTION', 'OOS_DESCRIPTION', 'JUSTIFICATION_IN_DELAY_LOGGING', 'AGREEMENT_WITH_OTHER_TESTS', 'PRODUCT_OR_MATERIAL_HISTORY',
        'ADDL_COMMENTS', 'JUSTIFICATION_FOR_CLIENT_INTIMATION', 'notifyTo',
        'JUSTIFICATION_OF_PHASEII', 'PHASEII_OBJECTIVE_AND_APPROACH', 'PHASEII_OUTCOME', 'PHASEII_RETESTING_PLAN', 'PHASEII_ROOTCAUSE_DETAILS', 'PHASEIII_SUMMARY_OF_RETESTING_EXECUTION', 'PHASEII_CONCLUSION', 'PHASEIII_RETESTING_ROOTCAUSE_DETAILS',
        'JUSTIFICATION_OF_PHASEIII', 'PHASEIII_OBJECTIVE_AND_APPROACH', 'PHASEIII_OUTCOME', 'PHASEII_RETESTING_PLAN', 'PHASEIII_ROOTCAUSE_DETAILS', 'PHASEIII_SUMMARY_OF_RETESTING_EXECUTION', 'PHASEIII_CONCLUSION', 'PHASEIII_RETESTING_ROOTCAUSE_DETAILS',
        'CAPA_VERIFICATION', 'CLOSURE_COMMENTS', 'ADDENDUM', 'PHASEII_RETESTING_OBJECTIVE', 'PHASEIII_RETESTING_OBJECTIVE', 'PHASEII_SUMMARY_OF_RETESTING_EXECUTION', 'PHASEII_RETESTING_RESULTS', 'PHASEIII_RETESTING_PLAN', 'PHASEIII_RETESTING_RESULTS', 'PHASEII_RETESTING_ROOTCAUSE_DETAILS'
      ]
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = limit;
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

  public focusSearch(value: any): void {
    setTimeout(() => {
      let requiredElement = document.getElementById(value); requiredElement?.focus();
    }, 0)
  }

  private getDynamicLabel(): void {
    this.isProcessing = true;

    const data = {
      tableName: 'QMS_OOS_GRID_VW',
      moduleName: 'OOS',
      gridName: 'OOS',
      groupId: this.qualityService.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          this.qualityService.activityDynamicLabel = acc;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  label: any = [];
  dynamicLabel: any = null;

  public statusAppearance(status: string): any {
    if (!status) {
      return null;
    }

    let color = '#0f3659';
    let background = '';
    let border = '0.75px solid #0f3659';

    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      color = '#FF3A29';
      background = '#FF3A291A';
      border = '0.75px solid #FF3A29';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      color = '#FF8900';
      background = '#FF89001A';
      border = '0.75px solid #FF8900';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      color = '#00E58F';
      background = '#00E58F1A';
      border = '0.75px solid #00E58F';
    } else if (status.includes('QA Accepted') || status.includes('Owner Acknowledged') || status.includes('Pending Closure Approval') ||
      status.includes('In Progress') || status.includes('Pending Closure Review') || status.includes('Pending QA Acceptance') ||
      status.includes('Pending Obsolete Approval')) {
      background = '#005C8A1A';
      border = '0.75px solid #005C8A1A';
    }

    return {
      color,
      background,
      border,
      'font-family': 'Poppins',
      'border-radius': '6px',
      'padding': '3px 9px',
      'font-size': '16px !important',
      'font-style': 'normal',
      'font-weight': '500',
      'line-height': '15px'
    };
  }

  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  async openAddWorkflow() {
    const status = this.qualityService.activity.status;
    if ((status == "In Progress" || status == "PhaseII In Progress" || status == "PhaseIII In Progress") && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {

      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
    } else this.addWorkflow = true;
    this.isProcessing = false;
  };

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element && (element.style.color = 'red');
    });
  }

  private async initiation(oos: any): Promise<void> {
    const validations = [
      { condition: this.dynamicLabel['INITIATING_DEPT_NAME'].isRemovable != 'Y' && !oos.initiatingDeptCode, id: 'initiating-department' },
      { condition: !oos.analysedBy, id: 'analyser' },
      { condition: !oos.dateOfOccurrence, id: 'oos-occurrence' },
      { condition: !oos.identifiedOn, id: 'oos-identified-on' },
      { condition: !oos.expectedToBeStartedOn, id: 'expected-to-be-started-on' },
      { condition: !oos.expcetedClosureOn, id: 'expected-closure-on' },
      { condition: !oos.owner, id: 'owner' },
      { condition: !oos.oosDeptCode, id: 'department' },
      { condition: this.isLocationIfOthers && !oos.locationIfOthers, id: 'location-if-others' },
      { condition: this.isProductIfOthers && !oos.productIfOthers, id: 'product-if-others' },
      { condition: this.isBatchRejectReason && !oos.batchRejectionJustification, id: 'batch-reject' },
      { condition: !oos.shortDescription, id: 'short-description' },
      { condition: !oos.oosDescription || this.isContentEmpty(oos.oosDescription), id: 'description' },
      { condition: !oos.productOrMaterialName, id: 'product-or-material-name' },
      { condition: !oos.testDetails, id: 'test-details' },
      { condition: !oos.testMethod, id: 'test-method' },
      { condition: !oos.testSpecification, id: 'test-specification' },
      { condition: !oos.instrumentOrEquipmentId, id: 'instrument-id' },
      { condition: !oos.instrumentOrEquipmentName, id: 'instrument-name' },
      { condition: !oos.obtainedResults, id: 'obtained-results' },
      { condition: !oos.concurrentBatchesResults, id: 'concurrent-batch-results' },
      { condition: !oos.agreementWithOtherTests || this.isContentEmpty(oos.agreementWithOtherTests), id: 'agreement' },
      { condition: !oos.productOrMaterialHistory || this.isContentEmpty(oos.productOrMaterialHistory), id: 'product-history' },
      { condition: oos.isClientIntimationReqd && (!oos.justificationForClientIntimation || this.isContentEmpty(oos.justificationForClientIntimation)), id: 'justification-client-info' },
      { condition: this.qualityService.activity.departmentHead != 0 && !oos.departmentHead, id: 'department-head' },
      { condition: this.qualityService.activity.departmentHead != 0 && !oos.oosDepartmentHead, id: 'oos-department-head' },
      { condition: !oos.qa, id: 'qa' },
      { condition: !oos.qaAcceptance, id: 'qa-acceptance' },
    ]

    const tab = 'oos?.oostType'
    await this.handleAsyncValidation(validations, tab);
  }

  private async preliminary(oos: any): Promise<void> {
    const validations = [
      { condition: !oos.sequenceOfEvents || this.isContentEmpty(oos.sequenceOfEvents), id: 'sequence' },
      { condition: !oos.immediateAction || this.isContentEmpty(oos.immediateAction), id: 'immediate-action' },
      { condition: !oos.initialImpactAssessment || this.isContentEmpty(oos.initialImpactAssessment), id: 'initial-impact' },
    ]

    const tab = 'Preliminary Actions'
    await this.handleAsyncValidation(validations, tab);
  }

  private async phaseII(oos: any): Promise<void> {

    const m = !this.message.isPhaseIIL1Frozen;
    const n = !this.message.isPhaseIIL2Frozen;
    const x = oos.phaseIIRetestingReqd;
    const y = oos.phaseIIIsRootCauseIdentifiedAtRetesting;

    const validations = [
      { condition: m && !oos.justificationOfPhaseII, id: 'p-2-justification' },
      { condition: m && !oos.phaseIIObjectiveAndApproach, id: 'p-2-objective' },
      { condition: n && !oos.phaseIIOutcome, id: 'p-2-outcome' },
      { condition: n && !oos.phaseIIRootcauseDetails, id: 'p-2-root-cause' },
      { condition: n && !oos.phaseIIConclusion, id: 'p-2-conclusion' },
      { condition: n && x && !oos.phaseIIRetestingObjective, id: 'p-2-r-objective' },
      { condition: n && x && !oos.phaseIIRetestingPlan, id: 'p-2-r-plan' },
      { condition: n && x && !oos.phaseIIRetestingNumberOfAnalyst, id: 'p-2-r-no-of-analyst' },
      { condition: n && x && !oos.phaseIIRetestingNumberOfAnalysis, id: 'p-2-r-no-of-analysis' },
      { condition: n && x && !oos.phaseIISummaryOfRetestingExecution, id: 'p-2-summary-of-r-execution' },
      { condition: n && x && !oos.phaseIIRetestingResults, id: 'p-2-r-results' },
      { condition: n && x && y && !oos.phaseIIRetestingRootcauseDetails, id: 'p-2-r-root-cause' },
    ]

    const tab = 'Phase II';
    await this.handleAsyncValidation(validations, tab);
  }

  private async phaseIII(oos: any): Promise<void> {

    const m = !this.message.isPhaseIIIL1Frozen;
    const n = !this.message.isPhaseIIIL2Frozen;
    const x = oos.phaseIIIRetestingReqd;
    const y = oos.phaseIIIIsRootCauseIdentifiedAtRetesting;

    const validations = [
      { condition: m && !oos.justificationOfPhaseIII, id: 'p-3-justification' },
      { condition: m && !oos.phaseIIIObjectiveAndApproach, id: 'p-3-objective' },
      { condition: n && !oos.phaseIIIOutcome, id: 'p-3-outcome' },
      { condition: n && !oos.phaseIIIRootcauseDetails, id: 'p-3-root-cause' },
      { condition: n && !oos.phaseIIIConclusion, id: 'p-3-conclusion' },
      { condition: n && x && !oos.phaseIIIRetestingObjective, id: 'p-3-r-objective' },
      { condition: n && x && !oos.phaseIIIRetestingPlan, id: 'p-3-r-plan' },
      { condition: n && x && !oos.phaseIIIRetestingNumberOfAnalyst, id: 'p-3-r-no-of-analyst' },
      { condition: n && x && !oos.phaseIIIRetestingNumberOfAnalysis, id: 'p-3-r-no-of-analysis' },
      { condition: n && x && !oos.phaseIIISummaryOfRetestingExecution, id: 'p-3-summary-of-r-execution' },
      { condition: n && x && !oos.phaseIIIRetestingResults, id: 'p-3-r-results' },
      { condition: n && x && y && !oos.phaseIIIRetestingRootcauseDetails, id: 'p-3-r-root-cause' },
    ]

    const tab = 'Phase III';
    await this.handleAsyncValidation(validations, tab);
  }

  private async evaluation(oos: any): Promise<void> {

    const validations = [
      { condition: !oos.overallInvestigationConclusion || this.isContentEmpty(oos.overallInvestigationConclusion), id: 'overall-investigation-conclusion' },
      { condition: !oos.overallRootcauseDetails || this.isContentEmpty(oos.overallRootcauseDetails), id: 'overall-root-cause' },
      { condition: oos.isCapaReqd && !oos.capaDetails, id: 'capa-details' },
      { condition: oos.isCapaReqd && (!oos.justificationForCapaImplementation || this.isContentEmpty(oos.justificationForCapaImplementation)), id: 'capa-justification' },]

    const tab = 'Data Evaluation';
    await this.handleAsyncValidation(validations, tab);
  }

  private async closure(oos: any): Promise<void> {

    const validations = [
      { condition: !oos.overallConclusion || this.isContentEmpty(oos.overallConclusion), id: 'overall-conclusion' },
      { condition: oos.isRecurring && (!oos.justificationForRecurring || this.isContentEmpty(oos.justificationForRecurring)), id: 'recurring-justification' },
      { condition: oos.isRecurring && !oos.recurringReferences, id: 'recurring-references' },
      { condition: !oos.batchDisposition, id: 'batch-disposition' },
      { condition: oos.batchDisposition?.trim()?.toLowerCase() == 'reject' && !oos.batchRejectionJustification, id: 'batch-reject' },
      { condition: oos.isCapaReqd && !oos.capaVerification, id: 'capa-verification' },
      { condition: !oos.closureComments, id: 'closure-comments' },
    ]

    const tab = 'Batch Disposition & Closure';
    await this.handleAsyncValidation(validations, tab);
  }

  private async handleAsyncValidation(validations: { condition: boolean, id: string }[], tab: string): Promise<void> {

    const invalidIds: string[] = validations.filter(v => v.condition).map(v => v.id);
    this.qualityService.validatedOosArray.push(invalidIds.length > 0 ? 'Failed' : 'Passed')
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    }
  }

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  update() {
    return new Promise<boolean>((resolve) => {
      this.qualityService.validatedOosArray = [];
      let validationPromises: Promise<void>[] = [];
      const status = this.qualityService.activity.status;
      const oos = this.qualityService.activity;

      if (!this.skipValidationsWhileSwitchingUser) {
        if (status == 'Draft' || status == 'Department Head Acceptance Rejected' || status == 'Department Head Acceptance Requested More Info.' || status == 'QA Acceptance Rejected' || status == 'QA Requested More Info.' || status == 'Owner Requested More Info.') {
          validationPromises.push(this.initiation(oos));
        } else if (status == 'Owner Acknowledged' || status == 'Department Head Approval Requested More Info.' || status == 'Department Head Approval Rejected' || status == 'QA Rejected' || status == 'Reviewer Requested More Info.' || status == 'Review Rejected' || status == 'Approver Requested More Info.' || status == 'Approval Rejected') {
          validationPromises.push(this.preliminary(oos));
        } else if (status == 'PhaseII Initiated' || status == 'PhaseII Reviewer Requested More Info.' || status == 'PhaseII Review Rejected' || status == 'PhaseII Approver Requested More Info.' || status == 'PhaseII Approval Rejected' || status == 'PhaseII In Progress') {
          validationPromises.push(this.phaseII(oos));
        } else if (status == 'PhaseIII Initiated' || status == 'PhaseIII Reviewer Requested More Info.' || status == 'PhaseIII Review Rejected' || status == 'PhaseIII Approver Requested More Info.' || status == 'PhaseIII Approval Rejected' || status == 'PhaseIII In Progress') {
          validationPromises.push(this.phaseIII(oos));
        } else if (status == 'Pending Data Evaluation' || status == 'Department Head Review Requested More Info.' || status == 'Department Head Review Rejected' || status == 'QA Review Rejected' || status == 'Closure Reviewer Requested More Info.' || status == 'Closure Review Rejected' || status == 'Closure Approver Requested More Info.' || status == 'Closure Approval Rejected') {
          validationPromises.push(this.evaluation(oos));
        } else if (status == 'Pending QA Review') {
          validationPromises.push(this.closure(oos));
        }
      }

      Promise.all(validationPromises)
        .then(() => {
          const isValid = !this.qualityService.validatedOosArray.includes('Failed');
          if (isValid) {
            this.prepareJson(this.qualityService.activity);
          } else {
            this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
          }
        }).catch((error) => {
          console.error('Error occurred during validation:', error);
          resolve(false);
        })
    })
  }

  private formatDate(date?: any): string | null {
    return date ? this.appService.dateZoneConvertion(new Date(date)) : null;
  }

  private mapBooleanToYN(value?: boolean): 'Y' | 'N' {
    return value ? 'Y' : 'N';
  }

  private mapUsersToString(users: any[]): string | null {
    return users?.length ? users.map(user => user.userId).join(',') : null;
  }

  prepareJson(oos: any = {}): void {
    const obj: any = {

      groupId: oos.groupId,
      oosNo: oos.oosNo,
      tempOosNo: oos.tempOosNo,
      oosId: oos.oosId,
      initiatingDeptCode: oos.initiatingDeptCode,
      oosDeptCode: oos.oosDeptCode,
      initiatedBy: oos.initiatedBy,
      departmentHead: oos.departmentHead,
      owner: oos.owner,
      qaAcceptance: oos.qaAcceptance,
      qa: oos.qa,
      analysedBy: oos.analysedBy,

      expectedToBeStartedOn: this.formatDate(oos.expectedToBeStartedOn),
      startedOn: this.formatDate(oos.startedOn),
      expcetedClosureOn: this.formatDate(oos.expcetedClosureOn),
      completedOn: this.formatDate(oos.completedOn),

      shortDescription: oos.shortDescription,
      oosDescription: oos.oosDescription,
      dateOfOccurrence: this.formatDate(oos.dateOfOccurrence),

      // So far not handled in UI
      loggedOn: oos.loggedOn,
      justificationInDelayLogging: oos.justificationInDelayLogging,
      operatingUnit: oos.operatingUnit,
      locationId: oos.locationId,
      productOrMaterialName: oos.productOrMaterialName,
      sampleType: oos.sampleType,
      batchType: oos.batchType,
      packDetails: oos.packDetails,
      testDetails: oos.testDetails,
      testMethod: oos.testMethod,
      testSpecification: oos.testSpecification,
      instrumentOrEquipmentName: oos.instrumentOrEquipmentName,
      instrumentOrEquipmentId: oos.instrumentOrEquipmentId,
      obtainedResults: oos.obtainedResults,
      agreementWithOtherTests: oos.agreementWithOtherTests,
      concurrentBatchesResults: oos.concurrentBatchesResults,
      productOrMaterialHistory: oos.productOrMaterialHistory,
      addlComments: oos.addlComments,

      isClientIntimationReqd: this.mapBooleanToYN(oos.isClientIntimationReqd),
      justificationForClientIntimation: oos.justificationForClientIntimation,
      notifyTo: this.mapUsersToString(this.selectedNotifyUsers),

      sequenceOfEvents: oos.sequenceOfEvents,
      immediateAction: oos.immediateAction,
      initialImpactAssessment: oos.initialImpactAssessment,

      isAnalyticalLabInvestigationReqd: this.mapBooleanToYN(oos.isAnalyticalLabInvestigationReqd),
      isMicrobiologyLabInvestigationReqd: this.mapBooleanToYN(oos.isMicrobiologyLabInvestigationReqd),
      phaseIIInvestigationReqd: this.mapBooleanToYN(oos.phaseIIInvestigationReqd),
      justificationOfPhaseII: oos.justificationOfPhaseII,
      phaseIIObjectiveAndApproach: oos.phaseIIObjectiveAndApproach,
      phaseIIOutcome: oos.phaseIIOutcome,
      phaseIIRootcauseDetails: oos.phaseIIRootcauseDetails,
      phaseIIConclusion: oos.phaseIIConclusion,
      phaseIIRetestingReqd: this.mapBooleanToYN(oos.phaseIIRetestingReqd),
      phaseIIRetestingObjective: oos.phaseIIRetestingObjective,
      phaseIIRetestingPlan: oos.phaseIIRetestingPlan,
      phaseIIRetestingNumberOfAnalyst: oos.phaseIIRetestingNumberOfAnalyst,
      phaseIIRetestingNumberOfAnalysis: oos.phaseIIRetestingNumberOfAnalysis,
      phaseIISummaryOfRetestingExecution: oos.phaseIISummaryOfRetestingExecution,
      phaseIIRetestingResults: oos.phaseIIRetestingResults,
      phaseIIIsRootCauseIdentifiedAtRetesting: this.mapBooleanToYN(oos.phaseIIIsRootCauseIdentifiedAtRetesting),
      phaseIIRetestingRootcauseDetails: oos.phaseIIRetestingRootcauseDetails,

      phaseIIIInvestigationReqd: this.mapBooleanToYN(oos.phaseIIIInvestigationReqd),
      justificationOfPhaseIII: oos.justificationOfPhaseIII,
      phaseIIIObjectiveAndApproach: oos.phaseIIIObjectiveAndApproach,
      phaseIIIOutcome: oos.phaseIIIOutcome,
      phaseIIIRootcauseDetails: oos.phaseIIIRootcauseDetails,
      phaseIIIRetestingReqd: this.mapBooleanToYN(oos.phaseIIIRetestingReqd),
      phaseIIIRetestingObjective: oos.phaseIIIRetestingObjective,
      phaseIIIRetestingPlan: oos.phaseIIIRetestingPlan,
      phaseIIIRetestingNumberOfAnalyst: oos.phaseIIIRetestingNumberOfAnalyst,
      phaseIIIRetestingNumberOfAnalysis: oos.phaseIIIRetestingNumberOfAnalysis,
      phaseIIISummaryOfRetestingExecution: oos.phaseIIISummaryOfRetestingExecution,
      phaseIIIRetestingResults: oos.phaseIIIRetestingResults,
      phaseIIIIsRootCauseIdentifiedAtRetesting: this.mapBooleanToYN(oos.phaseIIIIsRootCauseIdentifiedAtRetesting),
      phaseIIIRetestingRootcauseDetails: oos.phaseIIIRetestingRootcauseDetails,

      overallInvestigationConclusion: oos.overallInvestigationConclusion,
      overallRootcauseDetails: oos.overallRootcauseDetails,
      isCapaReqd: this.mapBooleanToYN(oos.isCapaReqd),
      overallConclusion: oos.overallConclusion,
      isRecurring: this.mapBooleanToYN(oos.isRecurring),
      justificationForRecurring: oos.justificationForRecurring,
      recurringReferences: oos.recurringReferences,
      rootcauseCategory: oos.rootcauseCategory,
      rootcauseCategoryIfOthers: oos.rootcauseCategoryIfOthers,

      oostType: oos.oostType,
      identifiedOn: this.formatDate(oos.identifiedOn),
      oosDepartmentHead: oos.oosDepartmentHead,
      locationIfOthers: oos.locationIfOthers,
      investigationTeam: this.mapUsersToString(this.selectedInvestigationUsers),
      justificationForCapaImplementation: oos.justificationForCapaImplementation,
      capaDetails: oos.capaDetails,
      batchDisposition: oos.batchDisposition ?? null,
      capaVerification: oos.capaVerification,
      closureComments: oos.closureComments,
      addendum: oos.addendum,

      ...this.isProductIfOthers && { productIfOthers: oos.productIfOthers },
      ...this.isBatchRejectReason && { batchRejectionJustification: oos.batchRejectionJustification }
    };

    this.execute(obj);
  }

  execute(obj: any) {
    this.isProcessing = true;
    this.appService.updateOos(obj).subscribe({
      next: (Response: any) => {
        this.message.lastmsg = Response;
        if (Response.resultType === 'S') {
          if (this.skipValidationsWhileSwitchingUser) {
            this.switchUserComponent.saveMethod();
            this.skipValidationsWhileSwitchingUser = false;
          } else if (this.flexibleComponent.flexibleFields.length) {
            this.flexibleComponent.save('activity', this.qualityService.activityId);
          }
          this.ngOnInit();
        }
        const isDynBtnUpdate = this.qualityService.isUpdatingOosThroughDynBtn;

        if (isDynBtnUpdate) {
          this.qualityService.isUpdatingOosThroughDynBtn = false;
        } else {
          this.showSnackBar(Response.result, Response.resultType);
        }

        this.isProcessing = false;
      },
      error: (error: Error) => {
        this.isProcessing = false;
        throw error;
      }
    })
  }

  private readonly model: {
    documents: any[];
    action: any[];
    preAction: any[],
    stagesUser: any[];
    extension: any[];
    effectiveness: any[];
    dependency: any[];
    parallelWorkFlow: any[];
  } = {
      documents: [],
      action: [],
      preAction: [],
      stagesUser: [],
      extension: [],
      effectiveness: [],
      dependency: [],
      parallelWorkFlow: [],
    };

  public on_documents_emit($event: any): void {
    this.model.action = $event.action;
  }

  public on_action_emit($event: any): void {
    this.model.documents = $event.documents;
  }

  public on_preAction_emit($event: any): void {
    this.model.preAction = $event.preAction;
  }

  public on_stageUser_emit($event: any): void {
    this.model.stagesUser = $event.stages;
  }

  public on_extension_emit($event: { $extension: any[], $destroying?: boolean }): void {
    if ($event?.$destroying) {
      this.appService.getOosByOosNo(this.qualityService.activityId).subscribe((oos: any) => {
        this.oos.expcetedClosureOn = this.qualityService.activity.expcetedClosureOn = new Date(oos.expcetedClosureOn);
      })
    }

    this.model.extension = $event.$extension;
  }

  public on_effectiveness_emit($event: any): void {
    this.model.effectiveness = $event.effectiveness;
  }

  public on_dependency_emit($event: any): void {
    this.model.dependency = $event.dependency;
  }

  public on_parallelWorkFlow_emit($event: any): void {
    this.model.parallelWorkFlow = $event.parallelWorkFlow;
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Justification In Delay Logging': this.dynamicLabel?.['JUSTIFICATION_IN_DELAY_LOGGING']?.fieldName,
      'OOS Description': this.dynamicLabel?.['OOS_DESCRIPTION']?.fieldName,
      'Agreement With Other Tests': this.dynamicLabel?.['AGREEMENT_WITH_OTHER_TESTS']?.fieldName,
      'Product Or Material History': this.dynamicLabel?.['PRODUCT_OR_MATERIAL_HISTORY']?.fieldName,
      'Justification For Client Intimation': this.dynamicLabel?.['JUSTIFICATION_FOR_CLIENT_INTIMATION']?.fieldName,
      'Sequence Of Events': this.dynamicLabel?.['SEQUENCE_OF_EVENTS']?.fieldName,
      'Immediate Action': this.dynamicLabel?.['IMMEDIATE_ACTION']?.fieldName,
      'Initial Impact Assessment': this.dynamicLabel?.['INITIAL_IMPACT_ASSESSMENT']?.fieldName,
      'Overall Investigation Conclusion': this.dynamicLabel?.['OVERALL_INVESTIGATION_CONCLUSION']?.fieldName,
      'Overall Rootcause Details': this.dynamicLabel?.['OVERALL_ROOTCAUSE_DETAILS']?.fieldName,
      'Justification For CAPA Implementation': this.dynamicLabel?.['JUSTIFICATION_FOR_CAPA_IMPLIMENTATION']?.fieldName,
      'Overall Conclusion': this.dynamicLabel?.['OVERALL_CONCLUSION']?.fieldName,
      'Justification For Recurring': this.dynamicLabel?.['JUSTIFICATION_FOR_RECURRING']?.fieldName
    };


    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.qualityService.activity[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qualityService.activity[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. Id → ', fieldId);
  }

  onStEditorChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    let isEmpty: boolean = false;
    items && (isEmpty = this.isContentEmpty(items));
    field && (field.style.color = isEmpty ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  isContentEmpty(content: string): boolean {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    const textContent = tempDiv.textContent ?? tempDiv.innerText ?? '';
    return textContent.trim().length === 0;
  }

  handleDropDownValidation(fieldId: string, item: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = item ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. Id → ', fieldId);
  }


  @ViewChild('searchUsersPopup', { static: true }) searchUsersPopup: TemplateRef<any>;
  visibleSearchUsersPopup: MatDialogRef<TemplateRef<any>>;

  searchUsersPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  qualityUserList: any = [];
  tempUsers: any = [];
  selectedNotifyUsers: any = [];
  selectedInvestigationUsers: any = [];
  searchUserParentCheckBox: boolean = false;
  currentIndex: any;
  previousIndex: any = null;
  uname: any;
  fname: any;
  lname: any;
  email: any;
  designation: any = null;
  department: any = null;
  popupTitle: string | null = 'title';
  isNotifyUsers: boolean = false;
  opensSearchUsersPopup(workingFor: string) {
    this.resetSearchUsers();
    this.popupTitle = "Search User(s)";
    this.isNotifyUsers = workingFor == 'notify';
    this.visibleSearchUsersPopup = this.dialog.open(this.searchUsersPopup, this.searchUsersPopupConfig);
  }

  resetSearchUsers() {
    [this.uname, this.fname, this.lname, this.email, this.designation, this.department] = new Array().fill(null);
    this.tempUsers = this.qualityUserList = [];
  }

  getUsers() {
    this[this.isNotifyUsers ? 'selectedNotifyUsers' : 'selectedInvestigationUsers'] = [...this[this.isNotifyUsers ? 'selectedNotifyUsers' : 'selectedInvestigationUsers'], ...this.tempUsers];
    this.visibleSearchUsersPopup.close();
  }

  cancelSearchUsersPopup() {
    this.visibleSearchUsersPopup.close();
  }

  searchUsersFunc() {
    this.isProcessing = true;
    let data = {
      userName: this.uname ? this.uname.toUpperCase() : "",
      firstName: this.fname,
      lastName: this.lname,
      emailAddress: this.email,
      designationCode: this.designation ?? null,
      departmentCode: this.department ?? null,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(data).subscribe((response: any) => {
      this.qualityUserList = response;
      this.qualityUserList.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
      this.isProcessing = false;
    })
  }

  onParentCheckBoxChanged(e: any) {
    this.tempUsers = [];

    if (e.target.checked) {
      this.onParentChecked();
    } else {
      this.onParentUnChecked();
    }
  }

  onParentChecked() {
    this.qualityUserList.every((user: any) => {
      if (user.emailAddress) {
        user.searchUserChildCheckBox = true;
        this.tempUsers.push({ userId: user.userId, userName: user.userName });
      }
      return true;
    })
  }

  onParentUnChecked() {
    this.qualityUserList.every((user: any) => {
      user.searchUserChildCheckBox = false;
      return true;
    })
  }

  onChildCheckBoxChanged(e: any, childData: any, idx: any) {
    if (e.target.checked) {
      childData.searchUserChildCheckBox = true;
      this.onChildChecked(childData);
    } else {
      childData.searchUserChildCheckBox = this.searchUserParentCheckBox = false;
      this.onChildUnchecked(childData);
    }
  }

  onChildChecked(checkedUser: any) {
    if (!this[this.isNotifyUsers ? 'selectedNotifyUsers' : 'selectedInvestigationUsers']?.some((user: any) => user.userId === checkedUser.userId)) {
      this.tempUsers.push({
        userId: checkedUser.userId,
        userName: checkedUser.userName
      })
    }

    if (this.qualityUserList.every((allUsers: any) => allUsers.searchUserChildCheckBox)) {
      this.searchUserParentCheckBox = true;
    }
  }

  onChildUnchecked(uncheckedUser: any) {
    const removal = this.tempUsers?.findIndex((removableUser: any) => removableUser.userId == uncheckedUser.userId);
    if (removal > -1) this.tempUsers?.splice(removal, 1);
  }

  onUserRemoved(index: any, workingFor: string) {
    if (index >= 0) this[workingFor == 'notify' ? 'selectedNotifyUsers' : 'selectedInvestigationUsers'].splice(index, 1);
  }

  removeAllUsers(workingFor: string) {
    this[workingFor == 'notify' ? 'selectedNotifyUsers' : 'selectedInvestigationUsers'] = [];
  }

  setStatusDependentAesthetic1() {
    this.message.isInitiationFrozen = false;
    this.message.isPreliminaryFrozen = true;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = true;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = true;
    this.message.showDependancySection = true;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = true;
    this.message.showPreliminaryTab = true;
    this.message.showDataEvaluationTab = true;
    this.message.showClosureTab = true;
    this.message.showRiskTab = false;
/* This function is temporary
 */  }

  taskStageUsers: any = [];

  getStageUsers() {
    const statusMap: { [key: string]: string } = {
      'Pending Review': 'Review', 'Review Inprogress': 'Review',
      'Pending Approval': 'Approve', 'Approval Inprogress': 'Approve',
      'Pending PhaseII Review': 'PhaseII Review', 'PhaseII Review Inprogress': 'PhaseII Review',
      'Pending PhaseII Approval': 'Approve', 'PhaseII Approval Inprogress': 'Approve',
      'Pending PhaseIII Review': 'PhaseIII Review', 'PhaseIII Review Inprogress': 'PhaseIII Review',
      'Pending PhaseIII Approval': 'Approve', 'PhaseIII Approval Inprogress': 'Approve'
    };

    const stageName = statusMap[this.oos.status] || '';

    if (stageName) {
      this.appService.getTaskStageUsers(this.oos.oosNo, 0, stageName).subscribe((stageUser: any) => {
        this.taskStageUsers = stageUser.filter((user: any) =>
          user.status != 'Review Completed' && user.status != 'PhaseII Review Completed' && user.status != 'PhaseIII Review Completed' && user.status != 'Approval Completed');
        this.setStatusDependentAesthetic();
      });
    } else {
      this.setStatusDependentAesthetic();
    }
  }
  getPreliminaryMandatory() {
    const status = this.qualityService.activity.status;

    const excludedStatuses = [
      'Draft',
      'Department Head Acceptance Rejected',
      'Department Head Acceptance Requested More Info.',
      'QA Acceptance Rejected',
      'QA Requested More Info.',
      'Owner Requested More Info.',
      'Pending Department Head Acceptance',
      'Pending QA Acceptance',
      'Deleted',
      'Pending Delete Approval',
      'Pending Obsolete Approval',
      'Obsoleted',
      'Department Head Accepted',
      'QA Accepted',
      'QA Approved',
      'Owner Acknowledgement Pending'
    ];

    return !excludedStatuses.includes(status);
  }

  @ViewChild('flexible') flexibleComponent!: FlexibleFieldsComponent;
  setStatusDependentAesthetic() {
    const loggedUserId = +this.message.getUserId()!;
    const { initiatedBy, owner, qa, qaAcceptance, status, departmentHead, oosDepartmentHead } = this.qualityService.activity;

    const isInitiator = initiatedBy == loggedUserId;
    const isOwner = owner == loggedUserId;
    const isQaApprover = qa == loggedUserId;
    const isQaAcceptance = qaAcceptance == loggedUserId;
    const isIDH = departmentHead == loggedUserId; /* IDH → Initiating Department Head */
    const isODH = oosDepartmentHead == loggedUserId; /* ODH → Owning Department Head */
    const isReviewer = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == loggedUserId);
    const isApprover = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == loggedUserId);

    switch (status) {
      case 'Draft':
      case 'Department Head Acceptance Rejected':
      case 'Department Head Acceptance Requested More Info.':
      case 'QA Acceptance Rejected':
      case 'QA Requested More Info.':
      case 'Owner Requested More Info.':
        this.initiator_aesthetic(isInitiator);
        break;

      case 'Pending Department Head Acceptance':
        this.idh_aesthetic(isIDH);
        break;

      case 'Pending QA Acceptance':
        this.pending_qa_acceptance_aesthetic(isQaAcceptance);
        break;

      case 'Owner Acknowledged':
      case 'Department Head Approval Requested More Info.':
      case 'Department Head Approval Rejected':
      case 'QA Rejected':
      case 'Reviewer Requested More Info.':
      case 'Review Rejected':
      case 'Approver Requested More Info.':
      case 'Approval Rejected':
      case 'Reopened':
        this.owner_phaseI_aesthetic(isOwner);
        break;

      case 'Pending Department Head Approval':
        this.odh_aesthetic(isODH);
        break;

      case 'Pending QA Approval':
        this.pending_qa_approval_aesthetic(isQaApprover);
        break;

      case 'QA Approved':
        this.qa_approved_aesthetic(isOwner);
        break;

      case 'Pending Review':
      case 'Review Inprogress':
        this.review_phaseI_aesthetic(isReviewer);
        break;

      case 'Pending Approval':
      case 'Approval Inprogress':
        this.approval_phaseI_aesthetic(isApprover);
        break;

      case 'PhaseII Initiated':
      case 'PhaseII Reviewer Requested More Info.':
      case 'PhaseII Review Rejected':
      case 'PhaseII Approver Requested More Info.':
      case 'PhaseII Approval Rejected':
        this.owner_phaseII_aesthetic(isOwner);
        break;

      case 'Pending PhaseII Review':
      case 'PhaseII Review InProgress':
        this.review_phaseII_aesthetic(isReviewer);
        break;

      case 'Pending PhaseII Approval':
      case 'PhaseII Approval Inprogress':
        this.approval_phaseII_aesthetic(isApprover);
        break;

      case 'PhaseIII Initiated':
      case 'PhaseIII Reviewer Requested More Info.':
      case 'PhaseIII Review Rejected':
      case 'PhaseIII Approver Requested More Info.':
      case 'PhaseIII Approval Rejected':
        this.owner_phaseIII_aesthetic(isOwner);
        break;

      case 'Pending PhaseIII Review':
      case 'PhaseIII Review InProgress':
        this.review_phaseIII_aesthetic(isReviewer);
        break;

      case 'Pending PhaseIII Approval':
      case 'PhaseIII Approval Inprogress':
        this.approval_phaseIII_aesthetic(isApprover);
        break;

      case 'Pending Data Evaluation':
      case 'Department Head Review Requested More Info.':
      case 'Department Head Review Rejected':
      case 'QA Review Rejected':
      case 'Closure Reviewer Requested More Info.':
      case 'Closure Review Rejected':
      case 'Closure Approver Requested More Info.':
      case 'Closure Approval Rejected':
        this.data_evaluation_aesthetic(isOwner);
        break;

      case 'Pending Department Head Review':
        this.dh_review_aesthetic(isODH);
        break;

      case 'Pending QA Review':
        this.qa_review_aesthetic(isQaApprover);
        break;

      case 'Pending Closure Review':
      case 'Closure Review Inprogress':
      case 'Pending Closure Approval':
      case 'Closure Approval Inprogress':
        this.closure_review_or_approval_aesthetic(isReviewer, isApprover);
        break;

      case 'Deleted':
      case 'Pending Delete Approval':
      case 'Pending Obsolete Approval':
      case 'Obsoleted':
      case 'Pending Reopen Approval':
      case 'Department Head Accepted':
      case 'QA Accepted':
      case 'Owner Acknowledgement Pending':
      case 'QA Reviewed':
      case 'Closed':
        this.negative_and_freeze_aesthetic();
        break;

      case 'In Progress':
      case 'PhaseII In Progress':
      case 'PhaseIII In Progress':
        this.inprogress_aesthetic(isOwner, status);
        break;
    }

    this.qualityService.elite_AccessToClosure_Reviewer_Approver =
      status == 'Pending Data Evaluation' ||
      status == 'Department Head Review Requested More Info.' ||
      status == 'Department Head Review Rejected' ||
      status == 'QA Review Rejected' ||
      status == 'Closure Reviewer Requested More Info.' ||
      status == 'Closure Review Rejected' ||
      status == 'Closure Approver Requested More Info.' ||
      status == 'Closure Approval Rejected' ||
      status == 'In Progress' ||
      status == 'PhaseII In Progress' ||
      status == 'PhaseIII In Progress';

    this.message.isLabTabsFrozen = status != 'Owner Acknowledged' && status != 'Draft'
    this.flexibleComponent.main();

  }

  setSwitchUserAesthetic(status: any, user: string): boolean {

    if (user == "owner") {
      this.qualityService.validSwitchStatus = status != 'Deleted' && status != 'Obsoleted';
      return this.qualityService.validSwitchStatus;
    } else {
      this.qualityService.validSwitchStatus = status != 'Deleted' && status != 'Obsoleted' && status != 'Closed'
      return this.qualityService.validSwitchStatus;
    };
  }

  initiator_aesthetic(isInitiator: boolean) {
    this.message.isInitiationFrozen = !isInitiator;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = !isInitiator;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = isInitiator;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isInitiator;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isInitiator;
    this.message.showRiskTab = false;
  }

  idh_aesthetic(isIDH: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isIDH;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  pending_qa_acceptance_aesthetic(isQaAcceptance: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isQaAcceptance;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  owner_phaseI_aesthetic(isOwner: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = !isOwner;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = isOwner;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = false;
  }

  odh_aesthetic(isODH: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isODH;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  pending_qa_approval_aesthetic(isQaApprover: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isQaApprover;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  qa_approved_aesthetic(isOwner: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = isOwner;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = false;
  }

  review_phaseI_aesthetic(isReviewer: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  approval_phaseI_aesthetic(isApprover: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isApprover;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  owner_phaseII_aesthetic(isOwner: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = !isOwner;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = isOwner;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = false;
  }

  review_phaseII_aesthetic(isReviewer: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }
  approval_phaseII_aesthetic(isApprover: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isApprover;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  owner_phaseIII_aesthetic(isOwner: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.isPhaseIIL2Frozen = true;
    this.message.isPhaseIIIL1Frozen = !isOwner;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = isOwner;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isOwner;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isOwner;
    this.message.showRiskTab = false;
  }

  review_phaseIII_aesthetic(isReviewer: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.isPhaseIIL2Frozen = true;
    this.message.isPhaseIIIL1Frozen = true;
    this.message.showDataEvaluationTab = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }
  approval_phaseIII_aesthetic(isApprover: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.isPhaseIIL2Frozen = true;
    this.message.isPhaseIIIL1Frozen = true;
    this.message.showDataEvaluationTab = true;
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isApprover;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  data_evaluation_aesthetic(isOwner: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.isPhaseIIL2Frozen = true;
    this.message.isPhaseIIIL1Frozen = true;
    this.message.isPhaseIIIL2Frozen = true;
    this.message.showDataEvaluationTab = true;
    this.message.isLevel1EvaluationFrozen = !isOwner;
    this.message.isLevel2EvaluationFrozen = true;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  dh_review_aesthetic(isODH: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.isPhaseIIL2Frozen = true;
    this.message.isPhaseIIIL1Frozen = true;
    this.message.isPhaseIIIL2Frozen = true;
    this.message.showDataEvaluationTab = true;
    this.message.isLevel1EvaluationFrozen = true;
    this.message.isLevel2EvaluationFrozen = true;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isODH;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  qa_review_aesthetic(isQaApprover: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.isPhaseIIL2Frozen = true;
    this.message.isPhaseIIIL1Frozen = true;
    this.message.isPhaseIIIL2Frozen = true;
    this.message.showDataEvaluationTab = true;
    this.message.isLevel1EvaluationFrozen = true;
    this.message.isLevel2EvaluationFrozen = !isQaApprover;
    this.message.showClosureTab = true;
    this.message.isClosureFrozen = !isQaApprover;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isQaApprover;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  closure_review_or_approval_aesthetic(isReviewer: boolean, isApprover: boolean) {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = true;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.isPhaseIIL2Frozen = true;
    this.message.isPhaseIIIL1Frozen = true;
    this.message.isPhaseIIIL2Frozen = true;
    this.message.showDataEvaluationTab = true;
    this.message.isLevel1EvaluationFrozen = true;
    this.message.isLevel2EvaluationFrozen = true;
    this.message.showClosureTab = true;
    this.message.isClosureFrozen = true;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer || isApprover;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  negative_and_freeze_aesthetic() {
    this.message.isInitiationFrozen = true;
    this.message.showPreliminaryTab = this.qualityService.activity.sequenceOfEvents;
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.isPhaseIIL2Frozen = true;
    this.message.isPhaseIIIL1Frozen = true;
    this.message.isPhaseIIIL2Frozen = true;
    this.message.showDataEvaluationTab = this.qualityService.activity.overallInvestigationConclusion;
    this.message.isLevel1EvaluationFrozen = true;
    this.message.isLevel2EvaluationFrozen = true;
    this.message.showClosureTab = this.qualityService.activity.batchDisposition;
    this.message.isClosureFrozen = true;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = false;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  inprogress_aesthetic(isOwner: boolean, status: string) {
    this.message.isPreliminaryFrozen = true;
    this.message.isPhaseIIL1Frozen = true;
    this.message.isPhaseIIL2Frozen = !(status == 'PhaseII In Progress' && isOwner);
    this.message.isPhaseIIIL1Frozen = true;
    this.message.isPhaseIIIL2Frozen = !(status == 'PhaseIII In Progress' && isOwner);
    this.message.showDataEvaluationTab = false;
    this.message.showClosureTab = false;
    this.message.showActionSection = true;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isOwner;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = false;
  }

  onWorkflowChildValueEmitted() {
    this.addWorkflow = false;
    this.parallelWorkflowList = null;
    this.appService.getWorkflowByRefNo(this.qualityService.activityId).subscribe((data: any) => {
      this.parallelWorkflowList = data;
    });
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('historyPopup', { static: true }) historyPopup: TemplateRef<any>;
  visibleHistoryPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  historyPopupConfig = {
    width: '130%',
    height: '90%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '90vw',
  };

  @ViewChild(HomepagetagComponent) homePageTagComponent!: HomepagetagComponent;
  openTag() {
    let data = {
      pageName: 'Detail',
      labelName: "Tag",
      tagRef: this.qualityService.SelectedGroupNameAndValue[0].groupCode + "-" + this.oos.crId
    }
    this.homePageTagComponent.openpopup(data);
  }

  openTopicPopup() {
    this.message.communicatingFrom = this.qualityService.moduleName;
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  cancelTopicPopup() {
    this.visibleTopicPopup.close();
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qualityService.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qualityService.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  @ViewChild(SwitchuserComponent) switchUserComponent!: SwitchuserComponent;
  /* Note : if (userBeingSwitched) param values changed then regarding names need to be changed in SwitchuserComponent too */
  async openswitchuser(userBeingSwitched: any) {
    if ((this.qualityService.activity.status == "In Progress" || this.qualityService.activity.status == "PhaseII In Progress" || this.qualityService.activity.status == "PhaseIII In Progress") && userBeingSwitched != "Owner" && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false; }
    this.message.switchedUser = this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = userBeingSwitched;
    if (userBeingSwitched == "Analyser") {
      this.message.switchedUser = this.message.switchUserCurrentValue = this.qualityService.activity.analysedBy;
      this.message.switchUserdropDownList = this.analyserDropDown;
    } else if (userBeingSwitched == "Owner") {
      this.message.switchedUser = this.message.switchUserCurrentValue = this.qualityService.activity.owner;
      this.message.switchUserdropDownList = this.ownerDropDown;
    } else if (userBeingSwitched == "QA") {
      this.message.switchedUser = this.message.switchUserCurrentValue = this.qualityService.activity.qa;
      this.message.switchUserdropDownList = this.qaDropDown;
    } else if (userBeingSwitched == "QA Acceptance") {
      this.message.switchedUser = this.message.switchUserCurrentValue = this.qualityService.activity.qaAcceptance;
      this.message.switchUserdropDownList = this.qaDropDown;
    } else if (userBeingSwitched == "Department Head") {
      this.message.switchedUser = this.message.switchUserCurrentValue = this.qualityService.activity.departmentHead;
      this.message.switchUserdropDownList = this.departmentHeadDropDown;
    } else if (userBeingSwitched == "OOS Department Head") {
      this.message.switchedUser = this.message.switchUserCurrentValue = this.qualityService.activity.oosDepartmentHead;
      this.message.switchUserdropDownList = this.departmentHeadDropDown;
    }
    this.switchUserComponent.openswitchuser(userBeingSwitched, "OOS");
  };

  onChildValueEmitted() {
    if (this.message.switchuserRole == "Analyser") {
      this.qualityService.activity.analysedBy = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Owner") {
      this.qualityService.activity.owner = this.message.switchedUser;
    } else if (this.message.switchuserRole == "QA") {
      this.qualityService.activity.qa = this.message.switchedUser;
    } else if (this.message.switchuserRole == "QA Acceptance") {
      this.qualityService.activity.qaAcceptance = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Department Head") {
      this.qualityService.activity.departmentHead = this.message.switchedUser;
    } else if (this.message.switchuserRole == "OOS Department Head") {
      this.qualityService.activity.oosDepartmentHead = this.message.switchedUser;
    }
    this.skipValidationsWhileSwitchingUser = true;
    this.update();
    this.switchUserComponent.visibleswitchUserPopup.close();
    this.switchUserComponent.visibleConfirmationPopup.close();
  }

  @ViewChild(AddMapCapaComponent) addMapCapaComponent!: AddMapCapaComponent;
  mapCapa() {
    this.addMapCapaComponent.openPopup();
  }

  onCapaEmitted() {
    this.qualityService.activity.capaDetails = this.message.addMapCapaComponentDetails.capaID + ' ' + this.message.addMapCapaComponentDetails.shortDescription;
  }

  unmapCapa() {
    this.qualityService.activity.capaDetails = null;
  }

  @ViewChild('openExportReportPopup', { static: true }) openExportReportPopup: TemplateRef<any>;
  visibleExportReportPopup: MatDialogRef<TemplateRef<any>>;

  exportReportPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  selectBoxForReportTemplate() {
    this.reportTemplateDropDown = [];
    this.reportTemplateList.forEach((template: any) => {
      this.reportTemplateDropDown.push({
        valueExp: template.qmsReportTemplateVwPk.templateId,
        displayExp: template.templateName
      });
    });
  }

  onReportTemplateSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('report-template', item);
    }
  }

  openExportPopup() {
    const defaultTemplate = this.reportTemplateList.find((t: any) => t.isDefault === 'Y');
    if (defaultTemplate) {
      this.selectedReportTemplate = defaultTemplate.qmsReportTemplateVwPk.templateId;
    }

    const { firstLevel: first, secondLevel: second, thirdLevel: third, fourthLevel: fourth } = this.message.breadcrumbData;
    const fileName = [first, second, third, fourth].filter(part => part != null).join('_') + '_';

    this.reportName = fileName + Date.now();
    this.visibleExportReportPopup = this.dialog.open(this.openExportReportPopup, this.exportReportPopupConfig);
  }

  cancelExportPopup() {
    this.visibleExportReportPopup.close();
  }

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const element of this.organizationReportImageDetails) {
              if (element.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: element.reportImageId,
                  displayExp: element.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const element of this.organizationReportImageDetails) {
          if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: element.reportImageId,
              displayExp: element.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const element of this.reportLogoDropdown) {
          if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = element.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('logo', item);
    }
  }

  reportTemplateFieldValidation: any;
  templateId: number;
  isSaveReport: boolean = false;
  selectedReportLogo: any = null;

  exportReport() {
    this.reportTemplateFieldValidation = document.getElementById('report-template') as HTMLInputElement;
    if (this.selectedReportTemplate) {
      /* Default template id for testing 17337; */
      let thirdL = this.message.breadcrumbData.secondLevel.split('>');
      let data1 = {
        "groupId": this.qualityService.activity.groupId + "",

        "gridName": "OOS",
        "templateId": this.selectedReportTemplate,
        "logoId": this.selectedReportLogo ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "attachAllDocuments": this.attachAllDocuments ? 'Y' : 'N',
        "reportName": this.reportName ?? "OOS_Report",
        "currentStatus": this.qualityService.activity.status,
        "groupName": thirdL[1],
        "OOSid": this.message.activityId,
        "version": "0",
        "OOSId": this.qualityService.activity.oosId
      }

      this.isProcessing = true;
      this.appService.genRateOOSReport(data1).subscribe((response: any) => {
        const blob = new Blob([response.body], { type: "application/pdf" });
        let downloadURL = globalThis.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        const { firstLevel: first, secondLevel: second, thirdLevel: third, fourthLevel: fourth } = this.message.breadcrumbData;
        const fileName = [first, second, third, fourth].filter(part => part != null).join('_') + '_';
        link.download = fileName + Date.now() + ".pdf";
        link.click();
        this.isProcessing = false;
      })
    } else {
      this.showSnackBar("Please enter the all mandatory fields...", 'E');
      this.reportTemplateFieldValidation.style.color = 'red';
    }
  }

  cancelReport() {
    this.visibleExportReportPopup.close();
  }

  reportFooterfieldValidation1: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  pdfDetailSearchText: string = '';
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterfieldValidation1 != undefined) {
        this.reportFooterfieldValidation1.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;

        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
        }
      },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });

  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qualityService.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

}
